import React, { useState } from "react";
import { motion } from "framer-motion";
import { FaHandHoldingMedical, FaUserFriends, FaCogs, FaShoppingCart } from "react-icons/fa";
import "./styles/cfss.css"; 

const Comparison = () => {
  const [activeTab, setActiveTab] = useState("CFSS");

  const comparisonData = [
    { 
      feature: "Service Flexibility", 
      cfss: "More flexibility in services", 
      pca: "Limited customization options", 
      icon: <FaCogs />
    },
    { 
      feature: "Who Can Provide Care?", 
      cfss: "Spouses & family members can provide care", 
      pca: "Spouses cannot provide care", 
      icon: <FaUserFriends />
    },
    { 
      feature: "Self-Direction", 
      cfss: "More self-direction options", 
      pca: "Fewer self-direction options", 
      icon: <FaHandHoldingMedical />
    },
    { 
      feature: "Goods & Equipment", 
      cfss: "Can purchase goods to aid independence", 
      pca: "No option to purchase assistive goods", 
      icon: <FaShoppingCart />
    },
  ];

  return (
    <div className="comparison-container">
      <h2 className="title"><h1><span className="hero-highlight">CFSS</span> vs <span className="hero-highlight">PCA</span></h1> Which One is Better for You?</h2>

      {/* Toggle Buttons */}
      <div className="toggle-buttons">
        <button className={`toggle-btn ${activeTab === "CFSS" ? "active" : ""}`} onClick={() => setActiveTab("CFSS")}>
          CFSS
        </button>
        <button className={`toggle-btn ${activeTab === "PCA" ? "active" : ""}`} onClick={() => setActiveTab("PCA")}>
          PCA
        </button>
      </div>

      {/* Animated Flip Cards */}
      <div className="card-container">
        {comparisonData.map((item, index) => (
          <motion.div 
            key={index} 
            className="flip-card" 
            whileHover={{ scale: 1.05 }}
          >
            <div className="flip-card-inner">
              {/* Front Side (Feature Name) */}
              <div className="flip-card-front">
                {item.icon}
                <h4>{item.feature}</h4>
              </div>

              {/* Back Side (Comparison) */}
              <div className={`flip-card-back ${activeTab.toLowerCase()}`}>
                <p>{activeTab === "CFSS" ? item.cfss : item.pca}</p>
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default Comparison;
